module.exports = __webpack_public_path__ + "static/media/user_confirm_data.a5877773.svg";